/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ViewActionSetFromJSON, ViewActionSetToJSON } from './ViewActionSet';
import { ZoneFromJSON, ZoneToJSON } from './Zone';
import { BlockFromJSON, BlockToJSON } from './Block';

/**
 * A structure that represents what should be rendered
 * @export
 * @interface View
 */

/**
 * Check if a given object implements the View interface.
 */
export function instanceOfView(value) {
  if (!('rid' in value) || value['rid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('rootBlockRID' in value) || value['rootBlockRID'] === undefined) return false;
  if (!('blocks' in value) || value['blocks'] === undefined) return false;
  return true;
}
export function ViewFromJSON(json) {
  return ViewFromJSONTyped(json, false);
}
export function ViewFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'rid': json['rid'],
    'id': json['id'] == null ? undefined : json['id'],
    'containerRID': json['containerRID'] == null ? undefined : json['containerRID'],
    'name': json['name'],
    'rootBlockRID': json['rootBlockRID'],
    'blocks': json['blocks'].map(BlockFromJSON),
    'zones': json['zones'] == null ? undefined : json['zones'].map(ZoneFromJSON),
    'actions': json['actions'] == null ? undefined : ViewActionSetFromJSON(json['actions'])
  };
}
export function ViewToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'rid': value['rid'],
    'id': value['id'],
    'containerRID': value['containerRID'],
    'name': value['name'],
    'rootBlockRID': value['rootBlockRID'],
    'blocks': value['blocks'].map(BlockToJSON),
    'zones': value['zones'] == null ? undefined : value['zones'].map(ZoneToJSON),
    'actions': ViewActionSetToJSON(value['actions'])
  };
}